import { G, Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Bullet: React.FC<Props> = ({ fill }) => {
    return (
        <Svg width={"12pt"} height={"100%"} fill={fill} id="Capa_1" x="0px" y="0px" viewBox="0 0 426.667 426.667">
            <G>
                <G>
                    <G>
                        <Path
                            d="M213.333,106.667c-58.88,0-106.667,47.787-106.667,106.667S154.453,320,213.333,320S320,272.213,320,213.333
				S272.213,106.667,213.333,106.667z"
                        />
                        <Path
                            d="M213.333,0C95.467,0,0,95.467,0,213.333s95.467,213.333,213.333,213.333S426.667,331.2,426.667,213.333
				S331.2,0,213.333,0z M213.333,384c-94.293,0-170.667-76.373-170.667-170.667S119.04,42.667,213.333,42.667
				S384,119.04,384,213.333S307.627,384,213.333,384z"
                        />
                    </G>
                </G>
            </G>
        </Svg>
    );
};

export default Bullet;
